module.exports = __webpack_public_path__ + "static/media/Portrait-10269.b2a89d53.jpg";